<mat-sidenav-container
  [style]="
    largeScreen ? 'height:calc(100vh - 70px)' : 'height:calc(100vh - 65px)'
  "
  autosize
>
  <mat-sidenav #sidenav fxLayout="column" mode="side">
    <div class="mat-sidenav">
      <div fxLayout="column" *ngFor="let itemMenus of menuItems | keyvalue">
        <div *ngFor="let itemMenu of itemMenus.value">
          <app-sidenav-item *ngIf="itemMenu  && (!itemMenu.subMenuId || itemMenu.subMenuId && openSubMenus.includes(itemMenu.subMenuId))" 
            [itemIcon]="itemMenu.menuIcon" 
            [itemTitle]="itemMenu.menuTitle"
            [itemRouterLink]="itemMenu.menuRouterLink" 
            [subMenu]="itemMenu.subMenu" itemTitleColor="#4a4a4d" itemTitleColorHover="#303f9f" itembackgroundColorHover="#b0b1b8"
            (click)="this.onSideNavClose(itemMenu); this.onItemClicked(itemMenu)"
            >
        </app-sidenav-item>
          <hr *ngIf="!itemMenu" width="100%" style="margin-top: 30px;">
        </div>
      </div>
    
    </div>
  </mat-sidenav>
  <mat-sidenav-content [style]='contentStyle'>
    <div
      class="container"
      fxLayout="column"
      style="min-width: 800px; margin-left: 15px; margin-right: 15px"
    >
      <router-outlet [appLoading]="this.isLoading()"></router-outlet>
    </div>
    <app-version  fxLayout fxLayoutAlign="flex-end"></app-version>
  </mat-sidenav-content>
</mat-sidenav-container>